var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_275_26184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 14,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95585 5.8374H18V12.0585H4.95585V5.8374Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_275_26184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.99959C18 10.0518 17.8194 11.0603 17.4889 12H5.13892V6H17.4889C17.8194 6.93884 18 7.94735 18 8.99959Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_275_26184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 11,
    width: 14,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95585 11.8511H17.6055V18.0001H4.95585V11.8511Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_275_26184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4889 12C17.2483 12.6821 16.9267 13.3277 16.5354 13.9239C14.9283 16.3783 12.1547 18 8.9996 18C7.61847 18 6.30944 17.6873 5.13892 17.1324V12H17.4889Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_275_26184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 14,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95585 0H17.6055V6.04455H4.95585V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_275_26184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4889 6H5.13892V0.866748C6.30944 0.311867 7.61847 0 8.9996 0C12.1523 0 14.9283 1.6209 16.5354 4.07533C16.9243 4.67234 17.2458 5.31713 17.4889 6Z",
    fill: "#006F2E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_275_26184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 6,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H5.16322V17.2427H0V0.860352Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_275_26184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.13892 0.866699V17.1324C4.21385 16.6925 3.37465 16.098 2.65533 15.3835C2.21061 14.942 1.81045 14.4511 1.46375 13.9238C0.53868 12.5087 0 10.8173 0 8.99955C0 7.18181 0.53868 5.49043 1.46375 4.07529C1.80883 3.54795 2.20899 3.05706 2.65533 2.61316C3.37465 1.90113 4.21385 1.30655 5.13892 0.866699Z",
    fill: "#F70000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUae);
export default __webpack_public_path__ + "static/media/UAE.e1499172f82b40f887b6409e037a3959.svg";
export { ForwardRef as ReactComponent };